import { EnrichedVideoEditorEditListItemDto } from '@app/modules/video-editions/types';

const PUBLISHED_PLATFORM_DISPLAY_STATUSES = ['COMPLETED', 'FAILED'] as const;

/** Platform row for social-export `UploadedPlatformsStatus` when driven from edit `publishedPlatforms` only. */
export type PublishedPlatformDisplayItem = { id: string; platform: string; status: string };

/**
 * Maps video editor published platform entries to display items (COMPLETED/FAILED only).
 * Used by edit card media overlay when showing platform pills from list payload.
 */
export function getPublishedPlatformDisplayItems(
  publishedPlatforms: EnrichedVideoEditorEditListItemDto['publishedPlatforms'],
): PublishedPlatformDisplayItem[] {
  if (!publishedPlatforms?.length) return [];
  return publishedPlatforms
    .filter((p) =>
      PUBLISHED_PLATFORM_DISPLAY_STATUSES.includes(
        p.status as (typeof PUBLISHED_PLATFORM_DISPLAY_STATUSES)[number],
      ),
    )
    .map((p) => ({ id: p.uploadId, platform: p.platform, status: p.status }));
}
